module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"or":"or","continue_with_google":"Continue with Google","google_exp":"Google is used for sign in only. User\u0027s roles and permissions remain unchanged."}}')
  delete Component.options._Ctor
}
